import { login } from '@wordpress/icons';

const SELECTORS = {
    confirmation: '.gform_confirmation_wrapper',
};

const getHeaderOffset = () => {
    const value = getComputedStyle(document.body).getPropertyValue('--header-height');

    return parseInt(value, 10) || 0;
};

const scrollToConfirmation = (formId) => {
    const selector = formId ? `#gform_confirmation_wrapper_${formId}` : SELECTORS.confirmation;

    const el = document.querySelector(selector);

    if (!el) return;

    const top = el.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - 30;
    window.scrollTo({ top, behavior: 'smooth' });
};

export const Form = () => {
    // Gravity Forms fires this jQuery event after AJAX confirmation renders
    if (window.jQuery) {
        window.jQuery(document).on('gform_confirmation_loaded', (event, formId) => {
            scrollToConfirmation(formId);
        });
    }

    // Non-AJAX submission: confirmation already in DOM on page load
    if (document.querySelector(SELECTORS.confirmation)) {
        scrollToConfirmation(null);
    }
};
